"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleArtNrUtils = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
/**
 * Provides utility methods for article numbers
 */
class ArticleArtNrUtils {
    /**
     * Either get the 'DE' or 'US' article number from `localizedArtNr`.
     * Returns null if both are not set.
     */
    static artNr(localizedArtNr) {
        return localizedArtNr ? echain_shared_i18n_1.LocaleService.getArtNrWithFallback(localizedArtNr) : undefined;
    }
    /**
     * Trims everything after the first dot.
     */
    static trimAfterFirstSeparator(artNr, logger) {
        const firstIndex = artNr.indexOf(echain_shared_i18n_1.LocaleService.getArtNrSeparator());
        if (firstIndex !== -1) {
            return artNr.substring(0, firstIndex + 1);
        }
        if (logger) {
            logger.warn('ArticleArtNrUtils.trimAfterFirstSeparator: Could not extract article number part');
        }
        return '';
    }
}
exports.ArticleArtNrUtils = ArticleArtNrUtils;
//# sourceMappingURL=ArticleArtNrUtils.js.map